import { api } from './client';

/** Endpoints de configuración y BYOK (ADMIN). Prefijo: /api/settings */

export interface ApiKeyPublic {
  id: string;
  provider: string;
  label: string | null;
  masked: string;
  createdAt?: string;
}

export interface Setting {
  key: string;
  value?: unknown;
  encrypted: boolean;
}

/** Horario operativo del agente (Tarea 6). */
export interface AgentSchedule {
  responder_desde: number;
  responder_hasta: number;
  horario_activo: boolean;
  timezone: string;
}

export const getAgentSchedule = () => api.get<AgentSchedule>('/api/settings/agent-schedule');

export const saveAgentSchedule = (schedule: AgentSchedule) =>
  api.put<AgentSchedule>('/api/settings/agent-schedule', schedule);

/** Avisos al dueño/soporte (operaciones, PASO 4). */
export interface OwnerAlerts {
  owner_phone: string;
}

export const getOwnerAlerts = () => api.get<OwnerAlerts>('/api/settings/ops-alerts');

export const saveOwnerAlerts = (settings: OwnerAlerts) =>
  api.put<OwnerAlerts>('/api/settings/ops-alerts', settings);

export const listSettings = () => api.get<Setting[]>('/api/settings');

export const getSetting = (key: string) => api.get<Setting>(`/api/settings/${key}`);

export const saveSetting = (key: string, value: unknown, encrypted?: boolean) =>
  api.put<{ key: string; encrypted: boolean }>(`/api/settings/${key}`, { value, encrypted });

export const getApiKeys = (provider?: string) =>
  api.get<ApiKeyPublic[]>('/api/settings/api-keys', { query: { provider } });

export const saveApiKey = (input: { provider?: string; key: string; label?: string }) =>
  api.post<ApiKeyPublic>('/api/settings/api-keys', { provider: 'anthropic', ...input });

export const rotateApiKey = (id: string, key: string) =>
  api.post<ApiKeyPublic>(`/api/settings/api-keys/${id}/rotate`, { key });

export const deleteApiKey = (id: string) =>
  api.del<{ success: boolean }>(`/api/settings/api-keys/${id}`);

export const testApiKey = (id: string) =>
  api.post<{ valid: boolean }>(`/api/settings/api-keys/${id}/test`);
